import React, { Component } from 'react';

import Icon from 'elements/Icon/Icon';
import { classnames, classname } from 'utils';

import './Footer.css';

export class Footer extends Component {
  cl = classname('footer');

  render() {
    const { className } = this.props;

    const classes = classnames(className, this.cl());

    return (
      <header className={classes}>
        <div className={this.cl('wrapper')}>
          <div className={this.cl('nav')}>
            <a href="/projects/">Проекты</a>
            <a href="/strategy/">Стратегия</a>
            <a href="/brands/">Брендинг</a>
            <a href="/ux-ui/">Дизайн интерфейсов (UX/UI)</a>
            <a href="/soft/">Веб-разработка</a>
            <a href="/media/">СММ</a>
            <a href="/performance/">Реклама</a>
          </div>
          <div className={this.cl('social')}>
            <a href="https://vk.com/nimax_agency" target="_blank" rel="noreferrer noopener">
              <Icon name={'vk'} />
            </a>
            {/* <a 
            href="https://www.facebook.com/nimax.ru" 
            target="_blank" 
            rel="noreferrer noopener"
          >
            <Icon name={'facebook'} />
          </a> */}
            <a
              href="https://www.youtube.com/channel/UCBzRw6EMHslbfIiqoQCCdKQ"
              target="_blank"
              rel="noreferrer noopener"
            >
              <Icon name={'youtube'} />
            </a>
            {/* <a href="http://instagram.com/Nimax_agency" target="_blank" rel="noreferrer noopener">
            <Icon name={'instagram'} />
          </a> */}
            <a href="https://www.behance.net/nimaxbrands" target="_blank" rel="noreferrer noopener">
              <Icon name={'behance'} />
            </a>
            <a href="https://dribbble.com/Nimax" target="_blank" rel="noreferrer noopener">
              <Icon name={'dribbble'} />
            </a>
            <a href="https://t.me/nimax_agency" target="_blank" rel="noreferrer noopener">
              <Icon name={'telegram'} />
            </a>
          </div>
        </div>

        <svg
          className={this.cl('svg')}
          width="1798"
          height="514"
          viewBox="0 0 1798 514"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 507.12V145.041H68.6619L77.5875 189.01H81.0172C92.9163 172.069 107.45 159.36 124.615 150.88C141.779 142.414 159.974 138.171 179.199 138.171C205.288 138.171 228.507 144.133 248.881 156.041C269.239 167.954 285.024 185.013 296.246 207.223C307.458 229.449 313.072 255.435 313.072 285.208V507.13H232.742V294.14C232.742 276.737 229.758 261.848 223.816 249.479C217.869 237.114 209.4 227.617 198.414 220.968C187.427 214.329 174.39 211.005 159.287 211.005C144.183 211.005 130.674 214.673 118.775 221.999C106.871 229.331 97.597 239.294 90.9733 251.885C84.3342 264.485 81.0172 278.574 81.0172 294.135V507.125H0V507.12ZM519.514 507.12V145.041H588.166L597.091 189.01H600.521C611.508 171.607 624.437 158.775 639.315 150.536C654.182 142.291 670.998 138.166 689.772 138.166C711.745 138.166 731.652 143.661 749.503 154.656C767.349 165.65 781.083 180.539 790.691 199.317H794.131C803.738 180.544 818.724 165.65 839.097 154.656C859.455 143.661 881.546 138.166 905.349 138.166C929.153 138.166 952.377 144.01 972.289 155.687C992.201 167.364 1007.65 184.197 1018.63 206.182C1029.62 228.171 1035.11 253.593 1035.11 282.448V507.115H954.781V292.062C954.781 274.203 951.915 259.206 946.204 247.062C940.478 234.933 932.352 225.883 921.832 219.921C911.296 213.975 899.397 210.989 886.129 210.989C872.862 210.989 861.757 214.314 851.458 220.953C841.163 227.597 833.027 236.986 827.085 249.125C821.138 261.269 818.16 275.578 818.16 292.062V507.115H737.153V292.062C737.153 274.203 734.287 259.206 728.565 247.062C722.839 234.933 714.713 225.883 704.193 219.921C693.658 213.975 681.764 210.989 668.491 210.989C656.135 210.989 644.693 214.314 634.162 220.953C623.632 227.597 615.394 236.986 609.452 249.125C603.495 261.269 600.521 275.578 600.521 292.062V507.115H519.514V507.12ZM1232.08 513.99C1200.95 513.99 1173.61 506.776 1150.04 492.349C1126.46 477.922 1108.04 456.625 1094.77 428.458C1081.49 400.286 1074.86 366.276 1074.86 326.427C1074.86 286.578 1081.49 252.459 1094.77 224.057C1108.05 195.664 1126.46 174.244 1150.04 159.817C1173.6 145.39 1200.95 138.176 1232.08 138.176C1255.87 138.176 1276.71 142.876 1294.56 152.265C1312.4 161.654 1327.51 173.905 1339.87 189.02H1343.3L1352.23 145.051H1420.2V507.13H1352.23L1343.3 463.849H1339.87C1327.51 478.963 1312.41 491.107 1294.56 500.265C1276.7 509.418 1255.87 514 1232.08 514V513.99ZM1247.87 441.167C1265.73 441.167 1281.51 436.939 1295.25 428.458C1308.98 419.982 1319.84 407.156 1327.86 389.979C1335.86 372.802 1339.87 351.623 1339.87 326.427C1339.87 301.231 1335.86 279.944 1327.86 262.536C1319.84 245.133 1308.98 232.199 1295.25 223.718C1281.51 215.242 1265.73 211.01 1247.87 211.01C1230.01 211.01 1214.23 215.248 1200.5 223.718C1186.77 232.199 1175.9 245.133 1167.89 262.536C1159.87 279.949 1155.88 301.251 1155.88 326.427C1155.88 363.993 1164.45 392.508 1181.62 411.969C1198.79 431.444 1220.86 441.172 1247.87 441.172V441.167ZM1454.73 507.125L1575.56 319.557L1461.59 145.046H1551.53L1627.05 267.343L1702.57 145.046H1791.13L1677.16 319.557L1798 507.125H1708.06L1625.68 374.521L1543.29 507.125H1454.73ZM413.161 96.8804C399.426 96.8804 387.871 92.3039 378.494 83.1356C369.107 73.9775 364.416 62.5261 364.416 48.7814C364.416 35.0366 369.107 23.4774 378.494 14.0834C387.866 4.70472 399.426 0 413.161 0C426.895 0 437.759 4.69959 447.151 14.0834C456.522 23.4774 461.224 35.0417 461.224 48.7814C461.224 62.521 456.527 73.408 447.151 82.7867C437.764 92.1808 426.429 96.8752 413.161 96.8752V96.8804ZM372.316 507.12V145.041H453.323V507.12H372.316Z"
            fill="white"
          />
        </svg>
      </header>
    );
  }
}
